import { render } from "./page-guide.vue?vue&type=template&id=089203f2"
import script from "./page-guide.js?vue&type=script&lang=js"
export * from "./page-guide.js?vue&type=script&lang=js"

import "./page-guide.vue?vue&type=style&index=0&id=089203f2&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__